export var SnsImPlatform;
(function (SnsImPlatform) {
    SnsImPlatform["FACEBOOK"] = "FACEBOOK";
    SnsImPlatform["LINKEDIN"] = "LINKEDIN";
    SnsImPlatform["INSTAGRAM"] = "INSTAGRAM";
})(SnsImPlatform || (SnsImPlatform = {}));
export var SnsImMessageType;
(function (SnsImMessageType) {
    SnsImMessageType["TEXT"] = "TEXT";
    SnsImMessageType["IMAGE"] = "IMAGE";
    SnsImMessageType["AUDIO"] = "AUDIO";
    SnsImMessageType["VIDEO"] = "VIDEO";
    SnsImMessageType["FILE"] = "FILE";
    SnsImMessageType["JSX"] = "JSX";
})(SnsImMessageType || (SnsImMessageType = {}));
export var SnsImMessageStatus;
(function (SnsImMessageStatus) {
    SnsImMessageStatus["SENDING"] = "SENDING";
    SnsImMessageStatus["SENT"] = "SENT";
    SnsImMessageStatus["ERROR"] = "ERROR";
    SnsImMessageStatus["DELIVERED"] = "DELIVERED";
    SnsImMessageStatus["SEEN"] = "SEEN";
})(SnsImMessageStatus || (SnsImMessageStatus = {}));
export var SnsImMessageDirection;
(function (SnsImMessageDirection) {
    SnsImMessageDirection["SEND"] = "SEND";
    SnsImMessageDirection["RECEIVE"] = "RECEIVE";
})(SnsImMessageDirection || (SnsImMessageDirection = {}));
export var SnsImLoadDirection;
(function (SnsImLoadDirection) {
    SnsImLoadDirection["EARLIER"] = "EARLIER";
    SnsImLoadDirection["NEWER"] = "NEWER";
})(SnsImLoadDirection || (SnsImLoadDirection = {}));
